export default function optionsToArray(options) {
  const optionsArray = []

  Object.keys(options).forEach(key => {
    optionsArray.push({
      [key]: options[key],
    })
  })
  return optionsArray
}

/**
 * Turns an id into the value shape expected by BaseUI Select: [] or [option].
 * @template T extends {id:any, label:string}
 * @param {T[]} options
 * @param {string|number|null|undefined} id
 * @returns {T[]}
 */
export function toSelectValue(options, id) {
  if (id === null || id === undefined || id === '') return []
  const opt = (options || []).find(o => String(o.id) === String(id))
  return opt ? [opt] : []
}

/**
 * Extracts the id from a BaseUI Select value (array with 0/1 option).
 * Always returns a string ('' when empty).
 * @param {Array<{id:any}>|undefined|null} value
 * @returns {string}
 */
export function idFromSelectValue(value) {
  return Array.isArray(value) && value.length ? String(value[0]?.id ?? '') : ''
}

/**
 * Maps any list of items into an options array ({id, label}, etc).
 * @template I,T
 * @param {I[]} items
 * @param {(item:I)=>T} mapFn // e.g.: item => ({ id: item.value, label: item.text })
 * @returns {T[]}
 */
